import Chart from "react-apexcharts";
import { useTranslation } from "../../../../hooks/useLocalization";
import ReportCard from "./ReportCard";

const ReportChannelsCard = ({ report, proPlan, isLoading }) => {
  const { t, tt } = useTranslation();
  return (
    <ReportCard
      variant="warning"
      helpText={t("The number of sessions for")}
      proPlan={proPlan}
      childrenHeader={<>{t("Sessions Per Channel")}</>}
      childrenFooter={<span>{tt("Total N", report.total)}</span>}
      isLoading={isLoading}
    >
      <div className="chart chart-donut w-100">
        <Chart
          options={report.options}
          series={report.data}
          type="donut"
          height="200"
        />
      </div>
    </ReportCard>
  );
};

export default ReportChannelsCard;
